import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { Avatar } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import UserProfile from 'aurora-images/user_profile.svg';
import messages from 'aurora-translations';
import { keyEmptyCheck } from 'aurora-utils/utils';
import styles from './styles';

const BrokerSummary = ({ classes, lang, broker }) => {
  const brokerData = {
    ...(broker?.licNumber && { registration_license_number: broker?.licNumber }),
    ...(broker?.companyNameEn && { company_name_english: broker?.companyNameEn }),
    ...(broker?.companyNameAr && { company_name_arabic: broker?.companyNameAr }),
    ...((broker?.companyTradeLic || broker?.companyTradeLic) && {
      LICENSE: broker?.companyTradeLic || broker?.companyTradeLic,
    }),
    ...(broker?.mobile && { Phone_Number: broker?.mobile }),
    ...((broker?.nationalityEn || broker?.nationalityAr) && {
      nationality: lang === 'en' ? broker?.nationalityEn : broker?.nationalityAr,
    }),
    ...(broker?.email && { email: broker?.email }),
  };
  return (
    <Grid container spacing={2}>
      <Grid textAlign='center' item md={4} xs={12}>
        <Avatar alt='Avatar alt' src={UserProfile} className={classes.large} />
        <Typography className={classes.propertyName}>
          {' '}
          <FormattedMessage {...messages.broker} /> <FormattedMessage {...messages.Name} />{' '}
        </Typography>
        <Typography className={classes.propertyValue} component='p' variant='h6'>
          {broker?.nameEn}
        </Typography>
        <Typography className={classes.propertyValue} component='p' variant='h6'>
          {broker?.nameAr}
        </Typography>
      </Grid>
      <Grid item md={8} xs={12} sm container>
        <Grid container spacing={2}>
          {Object.keys(brokerData).map(key => (
            <Grid key={key} item md={6} xs={6}>
              <Typography className={classes.propertyName}>{keyEmptyCheck(key)}</Typography>
              <Typography className={classes.propertyValue} component='p' variant='h6'>
                {brokerData[key]}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

BrokerSummary.propTypes = {
  classes: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  broker: PropTypes.object.isRequired,
};

export default withStyles(styles)(BrokerSummary);
